import {useMemo} from 'react'

import {useAppSelector} from '../../../../../../hooks/react-redux'
import {makePipelineFormErrorsSelector} from '../../EditPipelinePage.selectors'

function useSaveChangesError(pipelineId: string) {
  const selector = useMemo(() => makePipelineFormErrorsSelector(), [])
  const pipelineErrors = useAppSelector(state => selector(state, {pipelineId}))

  const flatErrors = useMemo(
    () =>
      Object.entries(pipelineErrors)
        .map(
          ([jobId, jobErrors]) =>
            [jobId, jobErrors!.flatMap(stepErrors => Object.values(stepErrors).flat())] as const,
        )
        .filter(([, jobErrors]) => jobErrors.length > 0),
    [pipelineErrors],
  )

  const prefixErrorMessage = 'Invalid settings in '
  const errorJobsString = useMemo(() => flatErrors.map(([jobId]) => jobId).join(', '), [flatErrors])
  const hasErrors = Boolean(flatErrors.length)
  const errorJobsLabel = useMemo(() => {
    const isOnlyOneError = flatErrors.length === 1 && flatErrors[0][1].length === 1
    if (isOnlyOneError) {
      const [_, [firstErrorMessage]] = flatErrors[0]
      return firstErrorMessage ? `${firstErrorMessage} in the ${errorJobsString}` : ''
    }
    return errorJobsString ? `${prefixErrorMessage} ${errorJobsString}` : ''
  }, [errorJobsString, flatErrors])

  return {
    hasErrors,
    errorJobsLabel,
  }
}

export default useSaveChangesError
